export default {
    props: {
        defaultFrom: {
            type: String,
            default: '',
        },
        defaultTo: {
            type: String,
            default: '',
        },
        presetLabels: {
            type: Object,
            default: () => ({}),
        },
        usePartnerDefaults: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            preset: '30',
            from: '',
            to: '',
        };
    },
    created() {
        if (this.usePartnerDefaults) {
            this.from = this.queryParams.from || this.defaultFrom;
            this.to = this.queryParams.to || this.defaultTo;
            this.preset = this.queryParams.preset || 'custom';

            return;
        }

        this.preset = this.queryParams.preset || '30';
        this.from = this.queryParams.from || '';
        this.to = this.queryParams.to || '';
    },
    methods: {
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        },
        formatYearMonth(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');

            return `${year}-${month}`;
        },
        partnerMaterializedThroughMonthDate() {
            if (this.defaultTo && /^\d{4}-\d{2}$/.test(this.defaultTo)) {
                const [year, month] = this.defaultTo.split('-').map((part) => parseInt(part, 10));

                return new Date(year, month - 1, 1);
            }

            const now = new Date();

            return new Date(now.getFullYear(), now.getMonth() - 1, 1);
        },
        setPresetDates(value) {
            const end = new Date();

            if (this.usePartnerDefaults) {
                const anchor = this.partnerMaterializedThroughMonthDate();

                if (value === 'all') {
                    this.from = '';
                    this.to = this.formatYearMonth(anchor);

                    return;
                }

                let spanMonths = 1;
                if (value === '3') {
                    spanMonths = 3;
                } else if (value === '6') {
                    spanMonths = 6;
                } else if (value === 'current') {
                    spanMonths = 1;
                }

                const start = new Date(
                    anchor.getFullYear(),
                    anchor.getMonth() - (spanMonths - 1),
                    1,
                );
                this.from = this.formatYearMonth(start);
                this.to = this.formatYearMonth(anchor);

                return;
            }

            let start = new Date(end.getFullYear(), end.getMonth(), end.getDate());

            if (value === 'all') {
                this.from = '';
                this.to = this.formatDate(end);

                return;
            }

            if (value === 'year') {
                start = new Date(end.getFullYear(), 0, 1);
            } else if (value !== 'custom') {
                start.setDate(start.getDate() - (parseInt(value, 10) - 1));
            }

            this.from = this.formatDate(start);
            this.to = this.formatDate(end);
        },
        buildPeriodParams() {
            const params = { preset: this.preset };

            if (this.preset === 'all') {
                if (this.to) {
                    params.to = this.to;
                }

                return params;
            }

            if (this.from) {
                params.from = this.from;
            }
            if (this.to) {
                params.to = this.to;
            }

            return params;
        },
        onPresetChange() {
            if (this.preset === 'custom' && this.usePartnerDefaults) {
                this.from = this.defaultFrom;
                this.to = this.defaultTo;
            } else {
                this.setPresetDates(this.preset);
            }

            this.fetchKpi(this.buildPeriodParams());
        },
        refreshPeriod() {
            if (this.preset !== 'custom') {
                this.setPresetDates(this.preset);
            }

            this.fetchKpi(this.buildPeriodParams());
        },
    },
};
